module.exports = __webpack_public_path__ + "static/media/bulb2.3aad262d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bulb2.svg
// module id = 1080
// module chunks = 0